import Game from 'Game';
import { HeuristicNoCoins, HeuristicPlaythrough } from './Personas/Heuristic';
import { RandomNoCoins, RandomPlaythrough } from './Personas/Random';
import { TipPlayerNoCoins, TipPlayerPlaythrough } from './Personas/Tip';
import {
    addSimulatorResult,
    finishSimulatorResults,
    initSimulatorUI,
    updateSimulatorResultsProgress,
} from './SimulatorUI';
import { ILevelDataFile } from 'System/Level/Data/ILevelDataFile';

const personas = [
    new RandomNoCoins(),
    new TipPlayerNoCoins(),
    new HeuristicNoCoins(),
    new RandomPlaythrough(),
    new TipPlayerPlaythrough(),
    new HeuristicPlaythrough(),
];
let attempts = 100;

export async function simulateLevel(levelData: ILevelDataFile): Promise<void> {
    window.simulating = true;
    const activePersonas = personas.filter((p) => p.enabled);

    initSimulatorUI(
        levelData.id,
        activePersonas.map((p) => p.id)
    );

    await Game.ticker.setTimeoutPromise(50);

    const start = performance.now();
    try {
        for await (const persona of activePersonas)
            addSimulatorResult(await persona.simulate(levelData, attempts, updateSimulatorResultsProgress));
    } catch (e) {
        console.log(e);
    }
    const end = performance.now();

    finishSimulatorResults(end - start);
    window.simulating = false;
}

export function getSimulatorPersonas(): string[] {
    return personas.map((p) => p.id);
}

export function personaEnabled(personaId: string, enabled?: boolean): boolean {
    const persona = personas.find((p) => p.id === personaId);
    if (!persona) return false;
    if (enabled === undefined) enabled = persona.enabled;
    else persona.enabled = enabled;
    return enabled;
}

export function getSimulationAttempts(): number {
    return attempts;
}

export function setSimulationAttempts(newAttempts: number): void {
    attempts = newAttempts;
}